// extracted by mini-css-extract-plugin
module.exports = {"main":"number_main__Ym0oL"};